import React from 'react'

export default function Icv() {
    return (
        <div>
            <>
                <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                <title>ÖZGEÇMİŞ</title>
                <meta name="author" content="oem" />
                {/* Removed global CSS overrides to inherit site styles */}
                <ol id="l1">
                    <li data-list-text="A.">
                        <p
                            className="s1"
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "20pt",
                                textIndent: "-14pt",
                                textAlign: "left"
                            }}
                        >
                            International publications:
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A1<span className="p">. </span>Isikoglu M
                            <span className="p">
                                , Has R, Korkmaz D, Bebek N, “Plexiform neurofibroma during and after
                                pregnancy,” Arch Gynecol Obstet, Nov;267(1):41-42 (2002).
                            </span>
                        </h2>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                lineHeight: "12pt",
                                textAlign: "justify"
                            }}
                        >
                            A2<span className="p">. Yuksel A, Has R, </span>Isikoglu M
                            <span className="p">
                                , Suoglu O, “Prenatal diagnosis of Caroli's disease,”
                            </span>
                        </h2>
                        <p
                            style={{
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                lineHeight: "12pt",
                                textAlign: "justify"
                            }}
                        >
                            Ultrasound Obstet Gynecol, May;19(5):525-526 (2002).
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A3. <span className="p">Akhan SE,</span>Isikoglu M
                            <span className="p">
                                , Salihoglu Y, Bengisu E, Berkman S, “Brain metastasis of ovarian
                                cancer after negative second-look laparotomy,” Eur J Gynaecol Oncol,
                                23(4):330- 332 (2002).
                            </span>
                        </h2>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            A4. Isikoglu M,{" "}
                            <span className="p">
                                Ozgur K, “Rapid decline in ovarian reserve after repeated ART cycles
                                in a 22 years old IVF patient,” Arch Gynecol Obstet, Aug;268(3):206-8
                                (2003). Epub 2003 Jun 25.
                            </span>
                        </h2>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A5. <span className="p">Yalcin O,</span>Isikoglu M
                            <span className="p">
                                , Beji N, “Results of TVT Operations Alone And Combined With Other
                                Vaginal Surgical Procedures,” Arch Gynecol Obstet, Jan;269(2):96-98
                                (2004). Epub 2002 Nov 01.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A6. <span className="p">Karan A,</span>Isikoglu M
                            <span className="p">
                                , Aksac B, Attar E, Eskiyurt N, Yalcin O, “Hypermobility syndrome in
                                105 women with pure urinary stress incontinence and in 105 controls,”
                                Arch Gynecol Obstet, Jan;269(2):89-90 (2004). Epub 2002 Oct 29.
                            </span>
                        </h2>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            A7. <span className="p">Aksac B, Aki S, Karan A, Yalcin A, </span>
                            Isikoglu M
                            <span className="p">
                                , Eskiyurt N, “Biofeedback and pelvic floor exercises for the
                                rehabilitation of urinary stress incontinence,” Gynecologic and
                                Obstetric Investigation, 56(1):23-27 (2003). Epub 2003 Jul 14.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A8. <span className="p">Ozgur K,</span>Isikoglu M
                            <span className="p">
                                ,“Cornual heterotopic pregnancy; conservative treatment with
                                transvaginal embryo reduction,” Arch Gynecol Obstet, Jan;271 (1):73-75
                                (2005).{" "}
                            </span>
                            <span className="s2">Epub 2004 Jan 13.</span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A9. <span className="p">Ozgur K,</span>Isikoglu M
                            <span className="p">
                                , Seleker M, Donmez L, “Semen quality of smoking and non- smoking men
                                in infertile couples in a Turkish population,” Arch Gynecol Obstet,
                                Feb; 271 (2):109-112 (2005)
                            </span>
                            <span className="s2">Epub 2003 Dec 18.</span>
                        </h2>
                        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>A10. </b>Yilmaz H; Ozgur K;
                            <b>Isikoglu M</b>; Sonmez C, Uner M, “Bone resorption starts at 14 days
                            of treatment with gonadotropin-releasing hormone agonist in{" "}
                            <i>in vitro </i>fertilization cycles,” Gynecological Endocrinology,
                            Jul;19 (1): 40-46 (2004)<span className="s2">.</span>
                        </p>
                        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A11. Isikoglu M
                            <span className="p">
                                , Senol Y, Berkkanoglu M, Ozgur K, Donmez L, Stones-Abbasi A, “Public
                                opinion regarding oocyte donation in Turkey: first data from a secular
                                population among the Islamic world,” Hum Reprod. Jan;21(1):318-323.{" "}
                            </span>
                            <span className="s2">Epub 2005 Aug 25 (2006)</span>
                        </h2>
                        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A12. Isikoglu M
                            <span className="p">
                                , Berkkanoglu M, Senturk Z, Coetzee K, Ozgur K, “Endometrial polyps
                                smaller than 1.5 cm do not affect ICSI outcome,” Reprod Biomed Online
                                Feb;12(2):199- 204 (2006)
                            </span>
                        </h2>
                        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=Abstract&list_uids=16785146&query_hl=1&itool=pubmed_docsum"
                                className="s4"
                                target="_blank"
                            >
                                A13. Isikoglu M,{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=Abstract&list_uids=16785146&query_hl=1&itool=pubmed_docsum"
                                className="a"
                                target="_blank"
                            >
                                Ozgur K, Oehninger S, Ozdem S, Seleker M
                            </a>
                            .{" "}
                            <span className="p">
                                “Serum anti-Mullerian hormone levels do not predict the efficiency of
                                testicular sperm retrieval in men with non- obstructive azoospermia,”
                                Gynecol Endocrinol, May;22(5):256-260 (2006).
                            </span>
                        </h2>
                        <p style={{ paddingTop: "7pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=AbstractPlus&list_uids=16849641&query_hl=1&itool=pubmed_docsum"
                                className="s4"
                                target="_blank"
                            >
                                A14.{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=AbstractPlus&list_uids=16849641&query_hl=1&itool=pubmed_docsum"
                                className="a"
                                target="_blank"
                            >
                                Tefs K, Gueorguieva M, Klammt J, Allen CM, Aktas D, Anlar FY, Aydogdu
                                SD, Brown D, Ciftci E, Contarini P, Dempfle CE, Dostalek M, Eisert S,
                                Gokbuget A,{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=AbstractPlus&list_uids=16849641&query_hl=1&itool=pubmed_docsum"
                                target="_blank"
                            >
                                Gunhan O, Hidayat
                            </a>
                        </p>
                        <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=AbstractPlus&list_uids=16849641&query_hl=1&itool=pubmed_docsum"
                                className="a"
                                target="_blank"
                            >
                                AA, Hugle B,{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=AbstractPlus&list_uids=16849641&query_hl=1&itool=pubmed_docsum"
                                className="s4"
                                target="_blank"
                            >
                                Isikoglu M
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?db=pubmed&cmd=Retrieve&dopt=AbstractPlus&list_uids=16849641&query_hl=1&itool=pubmed_docsum"
                                className="a"
                                target="_blank"
                            >
                                , Irkec M, Joss SK, Klebe S, Kneppo C, Kurtulus I, Mehta RP, Ornek K,
                                Schneppenheim R, Seregard S, Sweeney E, Turtschi S, Veres G, Zeitler
                                P, Ziegler M, Schuster{" "}
                            </a>
                            V. “Molecular and clinical spectrum of type I plasminogen deficiency: a
                            series of 50 patients,” Blood. Nov;1;108(9):3021-3026 (2006). Epub 2006
                            Jul 18. 2006 Jul 18; [Epub ahead of print]
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A15. <span className="p">Berkkanoglu M,</span>Isikoglu M
                            <span className="p">
                                , Seleker M, Ozgur K, “Flushing the endometrium prior to the embryo
                                transfer does not affect the pregnancy rate,” Reprod Biomed Online,
                                Aug;13(2):268-271 (2006).
                            </span>
                        </h2>
                        <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A16. <span className="p">Khalili MA,</span>Isikoglu M
                            <span className="p">
                                , Ghasemi M, “Attitudes of Christians and Muslims to an Oocyte
                                Donation Program in Iran,” Eubios Journal of Asian and International
                                Bioethics, 16 (3): 66- 71 (2006)
                            </span>
                        </h2>
                        <p style={{ paddingTop: "7pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A17. Isikoglu{" "}
                            <span className="p">
                                M, Berkkanoglu M, Senturk Z, Ozgur K, “Human Albumin does not prevent
                                OHSS in ART program: a prospective randomized placebo-controlled
                                double blind study,” Fertil Steril. 2007 Oct; 88 (4):982-5. Epub 2007
                                Feb 20.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                lineHeight: "12pt",
                                textAlign: "left"
                            }}
                        >
                            A18. <span className="p">Ozgur K, </span>Isikoglu M
                            <span className="p">
                                , Donmez L, Oehninger S, “Is hysteroscopic correction of an
                            </span>
                        </h2>
                        <p
                            style={{
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                lineHeight: "12pt",
                                textAlign: "left"
                            }}
                        >
                            incomplete uterine septum justified prior to IVF?” Reprod Biomed Online.
                            2007 Mar; 14(3);
                        </p>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            335-40
                        </p>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            A19. Isikoglu M
                            <span className="p">
                                , Ozgur K, Oehninger S, “Extension of GnRH-agonist through the luteal
                            </span>
                        </h2>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            phase does not improve ICSI outcome” J Reprod Med. 2007 Jul;52(7):639-44
                        </p>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            A20. Isikoglu M,{" "}
                            <span className="p">
                                Ozdem S, Berkkanoglu M, Jamal H, Senturk Z, Ozgur K, “Single dose 1,88
                                mg depot leuprolide is as efficient as daily short acting leuprolide
                                in ICSI cycles,” Hum Reprod, Jun;22(6): 1657-1661 (2007)
                            </span>
                            <span className="s2">. Epub 2007 Apr 12.</span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A21. Isikoglu M,{" "}
                            <span className="p">
                                Senol Y, Berkkanoglu M, Ozgur K, Donmez L, “Reply: Considerations of
                                Third Party Reproduction in Iran-Letter to the Editor” Hum Reprod,
                                Dec;22 (3):902-903 (2007)
                            </span>
                        </h2>
                        <h2
                            style={{
                                paddingTop: "11pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            A22. <span className="p">Berkkanoglu M, </span>Isikoglu M
                            <span className="p">
                                , Aydin D, Ozgur K, “Clinical effects of ovulation induction with
                                recombinant FSH supplemented with recombinant LH or low-dose
                                recombinant HCG in the midfollicular phase in microdose cycles in poor
                                responders,” Fertil Steril, Sep;88(3):665-9 (2007)
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A23. <span className="p">Berkkanoglu M,</span>Isikoglu M
                            <span className="p">
                                , Arici F, Ozgur K, “What is the best time to perform intracytoplasmic
                                sperm injection/embryo transfer cycle after hysteroscopic surgery for
                                an incomplete uterine septum?” Fertil Steril, Dec;90(6):2112-5 (2008)
                                doi: 10.1016/j.fertnstert.2007.10.018. Epub 2008 Jan 4.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A24. <span className="p">M Khalili, </span>M Isikoglu
                            <a
                                href="http://www.rbmonline.com/4DCGI/Article/Detail?38%091%09=%203390%09"
                                className="a"
                                target="_blank"
                            >
                                , N Tabibnejad, M Ahmadi, F Abed, M Parsanejad, M Ghasemi, H Jamal
                                “IVF staff attitudes towards oocyte donation: a multi-centric study
                                from Iran and{" "}
                            </a>
                            <span className="p">
                                Turkey” Reprod Biomed Online. 2008 Vol 17 Suppl 3: 61-66
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Germond%20M%5BAuthor%5D&cauthor=true&cauthor_uid=19079968"
                                className="s4"
                                target="_blank"
                                name="bookmark0"
                            >
                                A25.{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Germond%20M%5BAuthor%5D&cauthor=true&cauthor_uid=19079968"
                                className="a"
                                target="_blank"
                            >
                                Germond{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Wirthner%20D%5BAuthor%5D&cauthor=true&cauthor_uid=19079968"
                                className="a"
                                target="_blank"
                            >
                                M, Wirthner{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Senn%20A%5BAuthor%5D&cauthor=true&cauthor_uid=19079968"
                                className="a"
                                target="_blank"
                            >
                                D, Senn{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Lausanne%20Consensus%20Meeting%20on%20National%20ART%20Registers%5BCorporate%20Author%5D"
                                className="a"
                                target="_blank"
                            >
                                A; Lausanne Consensus Meeting on National ART{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/19079968"
                                className="a"
                                target="_blank"
                            >
                                Registers.{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Calhaz-Jorge%20C"
                                className="a"
                                target="_blank"
                            >
                                Collaborators: Calhaz-Jorge{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Castilla%20JA"
                                className="a"
                                target="_blank"
                            >
                                C, Castilla
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Cohen%20J"
                                className="a"
                                target="_blank"
                            >
                                JA, Cohen
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Consten%20D"
                                className="a"
                                target="_blank"
                            >
                                J, Consten
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=de%20Mouzon%20J"
                                className="a"
                                target="_blank"
                            >
                                D, de Mouzon{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Diaz%20NP"
                                className="a"
                                target="_blank"
                            >
                                J, Diaz{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Ferraretti%20AP"
                                className="a"
                                target="_blank"
                            >
                                NP, Ferraretti{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Gianaroli%20L"
                                className="a"
                                target="_blank"
                            >
                                AP, Gianaroli{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Gissler%20M"
                                className="a"
                                target="_blank"
                            >
                                L, Gissler
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Grygoruk%20C"
                                className="a"
                                target="_blank"
                            >
                                M, Grygoruk{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Gudleviciene%20Z"
                                className="a"
                                target="_blank"
                            >
                                C, Gudleviciene{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Hazekamp%20JT"
                                className="a"
                                target="_blank"
                            >
                                Z, Hazekamp{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Isikoglu%20M"
                                className="a"
                                target="_blank"
                            >
                                JT, Isikoglu
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Lidegaard%20%C3%98"
                                className="a"
                                target="_blank"
                            >
                                M, Lidegaard{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Karlstr%C3%B6m%20PO"
                                className="a"
                                target="_blank"
                            >
                                Ø, Karlström{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Korsak%20V"
                                className="a"
                                target="_blank"
                            >
                                PO, Korsak{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Kupka%20MS"
                                className="a"
                                target="_blank"
                            >
                                V, Kupka{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Limoni%20C"
                                className="a"
                                target="_blank"
                            >
                                MS, Limoni
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Mariller%20M"
                                className="a"
                                target="_blank"
                            >
                                C, Mariller{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Mayorga%20J"
                                className="a"
                                target="_blank"
                            >
                                M, Mayorga{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=McNab%20A"
                                className="a"
                                target="_blank"
                            >
                                J, McNab{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Merlet%20F"
                                className="a"
                                target="_blank"
                            >
                                A, Merlet{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Mocanu%20E"
                                className="a"
                                target="_blank"
                            >
                                F, Mocanu
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Nyboe%20Andersen%20A"
                                className="a"
                                target="_blank"
                            >
                                E, Nyboe Andersen{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Nygren%20KG"
                                className="a"
                                target="_blank"
                            >
                                A, Nygren{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Scaravelli%20G"
                                className="a"
                                target="_blank"
                            >
                                KG, Scaravelli{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Tomazevic%20T"
                                className="a"
                                target="_blank"
                            >
                                G, Tomazevic
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Urbancsek%20J"
                                className="a"
                                target="_blank"
                            >
                                T, Urbancsek{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Urdl%20W"
                                className="a"
                                target="_blank"
                            >
                                J, Urdl{" "}
                            </a>
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/?term=Yunakova%20M"
                                className="a"
                                target="_blank"
                            >
                                W, Yunakova{" "}
                            </a>
                            M. “Core data for assisted reproductive technology
                        </p>
                        <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/19079968"
                                className="a"
                                target="_blank"
                            >
                                registers: results of a consensus meeting.” Reprod Biomed{" "}
                            </a>
                            Online Dec;17(6):834-40 (2008)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A26.{" "}
                            <a
                                href="http://www.ncbi.nlm.nih.gov/pubmed/19225009"
                                className="a"
                                target="_blank"
                            >
                                Nyboe Andersen A, Goossens V, Bhattacharya S, Ferraretti AP, Kupka MS,
                                de Mouzon J, Nygren KG; European IVF-monitoring (EIM) Consortium, for
                                the European Society of Human Reproduction and Embryology (ESHRE)
                                Assisted reproductive technology and intrauterine inseminations in
                                Europe, 2005: results generated from European registers by ESHRE:
                                ESHRE. The European IVF Monitoring Programme (EIM), for the European
                                Society of Human Reproduction and Embryology{" "}
                            </a>
                            <span className="p">
                                (ESHRE). Hum Reprod. 2009 Jun;24(6):1267-87. doi:
                                10.1093/humrep/dep035. Epub 2009 Feb 18
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A27.{" "}
                            <span className="p">Kendirci A, Özçelik T N, Urfan A, Dönmez L, </span>
                            Isikoglu M
                            <span className="p">
                                . Characteristic cytoplasmic morphology of oocytes in endometriosis
                                patients and its effect on outcome of ART cycles IVF Lite
                                Mar-Apr;1(2):88-93 (2014).{" "}
                            </span>
                            DOI: <span className="p">10.4103/2348-2907.140123</span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A28. Isikoglu M
                            <span className="p">
                                . Book review on “Intrauterine Insemination” Jaypee Brothers Medical
                                Publishers (P) Ltd, New Delhi, India, 2014, 3rd ed., 562 pp,
                                Hardcover, ISBN: 978-93- 5090-403-9.The Journal of Obstetrics and
                                Gynecology of India Oct; 64 (5): 373-374 (2014) DOI
                                10.1007/s13224-014-0599-z.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A29. Isikoglu M
                            <span className="p">
                                . Heterotopic cervical pregnancy: conservative treatment with
                                transvaginal embryo aspiration IVF Lite Jan-Apr;2(1):37-41 (2015).
                                DOI: 10.4103/2348- 2907.158745
                            </span>
                        </h2>
                        <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A30. Isikoglu M
                            <a
                                href="https://www.ncbi.nlm.nih.gov/pubmed/26969646"
                                className="a"
                                target="_blank"
                            >
                                . Is it too early for a major change? A critical objection to the
                                freeze all{" "}
                            </a>
                            <span className="p">
                                policy. Arch Gynecol Obstet. 2016 Jun;293(6):1359-60. doi:
                                10.1007/s00404-016-4039-
                            </span>
                        </h2>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            4. Epub 2016 Mar 11.
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A31. Isikoglu M
                            <a
                                href="https://www.ncbi.nlm.nih.gov/pubmed/26924900"
                                className="a"
                                target="_blank"
                            >
                                . Arcuate Uterus: Does It Really Cause Pregnancy{" "}
                            </a>
                            <span className="p">
                                Loss? J Obstet Gynaecol India. 2016 Feb;66(1):6-9. doi:
                                10.1007/s13224-016-0847-5. Epub 2016 Feb 2.
                            </span>
                        </h2>
                        <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A32. Isikoglu M,{" "}
                            <span className="p">
                                Urfan Avci A, Koksal CD, Orta S Think Twice before Abdominal Delivery:
                                Adverse Effects of Caesarean Section on Fertility and on Embryo
                                Transfer Procedure Obstetrics and Gynecology International Journal.
                                2017 8(2): : 00285. DOI: 10.15406/ogij.2017.08.00285
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            A33. Isikoglu M,{" "}
                            <span className="p">
                                Aydinuraz B, Avci A, Kendirci Ceviren A Modified natural protocol
                                seems superior to natural and artificial protocols for preparing the
                                endometrium in frozen embryo transfer cycles Minerva Ginecol.
                            </span>
                            <span className="s5">
                                2020 May 13. doi: 10.23736/S0026- 4784.20.04570-0. Online ahead of
                                print
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            A34. Isikoglu M,{" "}
                            <span className="p">
                                Avci A, Kendirci Ceviren A, Aydınuraz B, Ata B Conventional IVF
                                revisited: Is ICSI better for non-male factor infertility? Randomized
                                controlled double blind study J Gynecol Obstet Hum Reprod. 2021
                                Sep;50(7):101990. doi: 10.1016/j.jogoh.2020.101990. Epub 2020 Nov 19.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            A35. Isikoglu{" "}
                            <span className="s5">
                                M, de Mouzon J. The experience of in vitro fertilization data
                                collection in Turkey. J Turk Ger Gynecol Assoc. 2021 Aug
                                31;22(3):235-241. doi: 10.4274/jtgga.galenos.2021.2020.0222. Epub 2021
                                May 3. PMID: 33938207; PMCID: PMC8420751.
                            </span>
                        </h2>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            A36. <span style={{ color: "#202020" }}>Isikoglu M</span>
                            <span className="s5">
                                , Ceviren AK, Cetin T, Avci A, Aydinuraz B, Akgul OK, Karaca M.
                                Comparison of ICSI and conventional IVF in non-male factor patients
                                with less than four oocytes. Arch Gynecol Obstet. 2022
                                Aug;306(2):493-499. doi: 10.1007/s00404-022- 06471-x. Epub 2022 Feb
                                27. PMID: 35224650.
                            </span>
                        </h2>
                        <h2
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            A37.{" "}
                            <span className="s5">
                                European IVF Monitoring Consortium (EIM), for the European Society of
                                Human Reproduction and Embryology (ESHRE); Wyns C, De Geyter C,
                                Calhaz-Jorge C, Kupka MS, Motrenko T, Smeenk J, Bergh C,
                                Tandler-Schneider A, Rugescu IA, Goossens V. ART in Europe, 2018:
                                results generated from European registries by ESHRE. Hum Reprod Open.
                                2022 Jul 5;2022(3):hoac022. doi: 10.1093/hropen/hoac022. PMID:
                                35795850; PMCID: PMC9252765.
                            </span>
                        </h2>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A38. Isikoglu Mete
                            <span className="p">
                                . Do not lose the moon while counting the stars: Conventional IVF
                                versus add-on treatments. Asian Pacific Journal of Reproduction
                                12(3):p 144-146, May 2023. | DOI: 10.4103/2305-0500.377505
                            </span>
                        </h2>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A39.{" "}
                            <span className="s5">
                                European IVF Monitoring Consortium (EIM) for the European Society of
                                Human Reproduction and Embryology (ESHRE); Smeenk J, Wyns C, De Geyter
                                C, Kupka M, Bergh C, Cuevas Saiz I, De Neubourg D, Rezabek K,
                                Tandler-Schneider A, Rugescu I, Goossens
                            </span>
                        </h2>
                        <p
                            className="s5"
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            V. ART in Europe, 2019: results generated from European registries by
                            ESHRE†. Hum Reprod. 2023 Dec 4;38(12):2321-2338. doi:
                            10.1093/humrep/dead197. PMID: 37847771; PMCID: PMC10694409.
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            className="s5"
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <span className="h2">A40.</span>Benlioğlu C, Aydın Y, Bahçeci M, Baltacı
                            V, Bulgurcuoğlu S, Demir A, Dilbaz S, Ergin E, Fındıklı N, Göksever
                            Çelik H, Güler İ, <b>Işıkoğlu M</b>, Mümüşoğlu S, Özekinci M, Özörnek H,
                            Şimşek E, Şükür YE, Uncu G, Urman B, Vicdan K, Yaralı H, Balaban B, Ata
                            B. Demographic distributions and clinical results of assisted
                            reproduction techniques in Turkey in 2019: a descriptive survey. J Turk
                            Ger Gynecol Assoc. 2024 Mar 6;25(1):18-23. doi:
                            10.4274/jtgga.galenos.2023.2023-3-12. PMID: 38444322; PMCID:
                            PMC10921078.
                        </p>
                        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            A41. Isikoglu Mete
                            <span className="p">
                                . Semen features for conventional IVF: Need for a simple universal
                                index. Asian Pacific Journal of Reproduction (Baskıda)
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                    </li>
                    <li data-list-text="B.">
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <u>
                                Uluslararası bilimsel toplantılarda sunulan ve bildiri kitabında (
                            </u>
                            <u>
                                <i>Proceedings</i>
                            </u>
                            <u>)</u> <u>basılan bildiriler : (International presentations)</u>
                        </h2>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B1. </b>Yalçın Ö, Karan A, <b>Işıkoğlu M</b>, Eskiyurt N, Attar E,
                            Aksaç B, “Hypermobility Syndrome in Patients With Stress Urinary
                            Incontinence,”{" "}
                            <i>Proc. ICS 2000. International Continence Society Annual Meeting</i>,
                            28-31.8.2000 Tampere, Finland
                        </p>
                        <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B2. </b>Yalcin O, <b>Isikoglu M</b>, Ayyıldız H, Gunay S, Yazici G,
                            “Combination of “tension free vaginal tape procedure with other
                            abdominal and vaginal gynecologic operations,”{" "}
                            <i>
                                Proc. XXVth IUGA Congress October 22-25, 2000 Rome, Italy
                                International Urogynecology Journal and Pelvic Floor Dysfunction{" "}
                            </i>
                            Vol 11, Suppl 1 2000 p:94
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B3. </b>Yalcin O, <b>Isikoglu M</b>, Beji NK, Topuz S, “Comparison of
                            Tension free vaginal tape procedure with Burch colposuspension for the
                            patients with stress urinary incontinence,”{" "}
                            <i>Proc. XXVIth IUGA Congress </i>December 3-5, 2001 Melbourne,
                            Australia{" "}
                            <i>International Urogynecology Journal and Pelvic Floor Dysfunction </i>
                            Vol 12, Suppl 3. 139. 2001
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B4. </b>Aksaç B, Aki S, Karan A, Yalçın Ö, <b>Işıkoğlu M</b>,
                            Eskiyurt N, “Biofeedback and pelvic floor muscle exercises for the
                            rehabilitation of stress urinary incontinence,”{" "}
                            <i>Proc. ICS 2002. International Continence Society Annual Meeting</i>,
                            28-30.8.2002 Heilderberg, Germany
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            B5. <span className="p">Ozgur K,</span>Isikoglu M
                            <span className="p">
                                , Seleker M, “Continuation of Gonadotropin Releasing Hormone
                            </span>
                        </h2>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            Agonist During The Luteal Phase In In Vitro Fertilization Patients: Is
                            it Beneficial?” <i>Proc.</i>
                        </p>
                        <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <i>
                                58th Annual Meeting of the American Society for Reproductive Medicine
                                (ASRM){" "}
                            </i>
                            October 12-17, <b>2002</b>, in Seattle, Washington, USA (oral
                            presentation) (Fertil Steril 2002-vol 76 no:3S)
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>B6</b>. Ozgur K,
                            <b>Isikoglu M, </b>“Transvaginal Route Seems To Be The Safest Way For
                            Early Multifetal Pregnancy Reduction,”{" "}
                            <i>
                                Proc. 58th Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM)
                            </i>
                            October 12-17, 2002, in Seattle, Washington, USA (poster presentation)
                            (Fertil Steril 2002-vol 76 no:3S){" "}
                            <i>
                                58th Annual Meeting of the American Society for Reproductive Medicine
                                (ASRM)
                            </i>
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B7. Isikoglu M, </b>Ozgur K, “Does endometrial thickness predict ICSI
                            outcome?”, <i>Proc. 19th Annual meeting of ESHRE</i>, Madrid, 29 June-2
                            July 2003.
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>B8. </b>Ozgur K,
                            <b>Isikoglu M</b>, Oehninger S, Donmez L, “The hysteroscopic correction
                            of an incomplete uterine septum may have a positive impact on IVF
                            outcome,”{" "}
                            <i>
                                Proc. 59th Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 11-15, 2003, in San Antonio, Texas, USA (oral presentation)
                            (Fertil Steril 2003-vol 80 Suppl 3 no:S35)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B9. </b>Berkkanoglu M, <b>Isikoglu M</b>, Seleker M, Ozgur K,
                            ”Flushing the endometrium prior to the embryo transfer does not improve
                            the pregnancy rate; a prospective randomized study,”{" "}
                            <i>
                                Proc. 60th Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 16-20, 2004, in Philadelphia, Pennsylvania, USA (poster
                            presentation) (Fertil Steril 2004-vol 82 Suppl 2 no:S201)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B10. Isikoglu M</b>, Berkkanoglu M, Sentürk Z, Ozgur K, “Human
                            albumin is not efficient for the prevention of severe ovarian
                            hyperstimulation syndrome (OHSS): a prospective randomized placebo
                            controlled double blind study,”
                            <i>
                                Proc. 60th Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 16-20, 2004, in Philadelphia, Pennsylvania, USA (oral
                            presentation) (Fertil Steril 2004-vol 82 Suppl 2 no:S33)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B11. </b>Ozgur K, <b>Isikoglu M</b>,<span className="s8">“</span>
                            Outcome of 106 high order multifetal pregnancies after transvaginal
                            pregnancy reduction and comparison with nonreduced twins,”{" "}
                            <i>
                                Proc. 60th Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 16-20, 2004, in Philadelphia, Pennsylvania, USA (oral
                            presentation) (Fertil Steril 2004-vol 82 Suppl 2 no:S133)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B12. </b>Senturk Z, <b>Isikoglu M</b>, Berkkanoglu M, Ozgur K,
                            “Endometrial polyps encountered during controlled ovarian stimulation do
                            not affect ICSI outcome”, <i>Proc. </i>21st{" "}
                            <i>Annual meeting of ESHRE</i>, Copenhagen, 19-22 June 2005 (oral
                            presentation).
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B13. </b>Özgür K, <b>Isikoglu M</b>, “Successful outcome of 152 high
                            order multifetal pregnancies after transvaginal pregnancy reduction and
                            comparison with nonreduced twins,” <i>Proc. 13</i>
                            <span className="s9">th </span>
                            <i>
                                World congress on in vitro fertilization assisted reproduction and
                                genetics
                            </i>
                            , İstanbul May 26-29 2005
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B14. Isikoglu M</b>, Yigiter Y, Berkkanoglu M, Ozgur K, A
                            Stones-Abbasi, “Public opinion regarding oocyte donation in Turkey:
                            First data from a secular population among the islamic world,” Proc. 13
                            <span className="s8">th </span>World congress on in vitro fertilization
                            assisted reproduction and genetics, İstanbul May 26-29 2005
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B15. </b>Berkkanoglu M, <b>Isikoglu M</b>, Ozgur K, “Clinical Effects
                            of Ovulation Induction With Recombinant FSH (rFSH) Supplemented With
                            Recombinant LH (rLH) or Low-dose Recombinint HCG (rHCG) in the
                            Midfollicular Phase in Microdose Cycles”,{" "}
                            <i>
                                Proc. 61st Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM)
                            </i>
                            October 15-19, 2005, 2005, Montreal, Canada (oral presentation) (Fertil
                            Steril 2005-vol 84 Suppl 1 no:S-44)
                        </p>
                        <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>B16. </b>Berkkanoglu M, <b>Isikoglu </b>M, Ozgur K, “When to perform
                            ICSI/ET Cycle After Hysteroscopic Surgery for Uterine Septum?”,{" "}
                            <i>
                                Proc. 61st Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM)
                            </i>
                            October 15-19, 2005, 2005, Montreal, Canada (oral presentation) (Fertil
                            Steril 2005-vol 84 Suppl 1 S-50)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B17. </b>Berkkanoglu M, Ozgur K,
                            <b>Isikoglu </b>M, “Comparison of ART outcomes after hysteroscopic
                            correction of incomplete uterine septum above and below 10 mm”,{" "}
                            <i>
                                Proc. 61st Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 15-19, 2005, Montreal, Canada (poster presentation) (Fertil
                            Steril 2005-vol 84 Suppl 1 no:S-360)
                        </p>
                        <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B18. </b>Berkkanoglu M, Ozgur K,
                            <b>Isikoglu </b>M, “Uterine Subseptus: A Quantification is lacking”,{" "}
                            <i>
                                Proc. 61st Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 15-19, 2005, Montreal, Canada (poster presentation) (Fertil
                            Steril 2005- vol 84 Suppl 1 no:S-204)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B19. </b>Jamal H, Seleker M, Berkkanoglu M, <b>Isikoglu M</b>,
                            Senturk Z, Ozgur K Slow and intermittent embryo transfer: a prospective
                            cohort study. 22nd <i>Annual meeting of ESHRE</i>, Prague, 18-21 June
                            2006 (poster presentation).
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B20. </b>Berkkanoglu M, Senturk Z,
                            <b>Isikoglu M</b>, Jamal H, Ozgur K Total embryo freezing plus dual
                            rennin-angiotensin blockade therapy reduce weight gain effectively in
                            early OHSS. 22nd <i>Annual meeting of ESHRE</i>, Prague, 18-21 June 2006
                            (poster presentation).
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B21. Isikoglu M</b>, Ozdem S, Berkkanoglu M, Jamal H, Senturk Z,
                            Ozgur K, “Comparison of 1,88 mg depot leuprolide with classical long
                            protocol in ICSI cycles: efficiency and effectiveness”{" "}
                            <i>
                                Proc. 62nd Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 21-25, 2006, New Orleans, USA (poster presentation) (Fertil
                            Steril 2006-vol 86 Suppl 2 no:S416)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B22. </b>Ozgur K, <b>Isikoglu M</b>, Berkkanoglu M, “Fetal Reduction
                            To Singleton: Is it Justified For ART Multifetal Pregnancies?”{" "}
                            <i>
                                Proc. 62nd Annual Meeting of the American Society for Reproductive
                                Medicine (ASRM){" "}
                            </i>
                            October 21-25, 2006, New Orleans, USA (poster presentation) (Fertil
                            Steril 2006-vol 86 Suppl 2 no:S165)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            B23.{" "}
                            <span className="p">Kendirci A, Özçelik TN, Urfan A, Dönmez L, </span>
                            Işıkoğlu M
                            <span className="p">
                                , ÜYTE Uygulamalarında ardışık ve ardışık olmayan kültür ortamlarının
                                kıyaslanması. İkinci Uluslararası Klinik Embriyoloji Derneği Kongresi,
                                Sarıgerme, 23-25 Eylül 2011) (poster sunumu)
                            </span>
                        </h2>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>B24. </b>Kendirci A, Özçelik TN, Urfan A, Dönmez L, <b>Işıkoğlu M</b>
                            . Typical morphology of oocytes in endometriosis patients and its effect
                            on ART outcome. <i>28th Annual meeting of ESHRE June 2012 Istanbul </i>
                            (poster sunumu) Abstract book of the 28th ESHRE Annual Meeting, Turkey 1
                            July - 4 July 2012 <i>Volume 27 suppl 2 2012</i>
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <span className="s10" style={{ backgroundColor: "" }}>
                                B25.{" "}
                            </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Urfan A,{" "}
                            </span>
                            <span className="s10" style={{ backgroundColor: "" }}>
                                Isikoglu M
                            </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                , Kendirci Cevien A, Aydinuraz B, Urshanova A. Conventional IVF
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                revisited: is ICSI really better for non-male factor infertility?
                                Randomized controlled double
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                blind study.{" "}
                            </span>
                            <span className="s12" style={{ backgroundColor: "" }}>
                                33th Annual meeting of ESHRE June 2017 Geneva
                            </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                (poster sunumu) Abstract
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                book of the 33th ESHRE Annual Meeting, Switzerland 2 July - 5 July
                                2017
                            </span>
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <span className="s10" style={{ backgroundColor: "" }}>
                                B26. Isikoglu Mete,{" "}
                            </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Aydinuraz Batu; Urshanova Amilya, Urfan Avci Aysenur
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Hysteroscopic evaluation is justified in recurrent miscarriage cases.
                                ESGE 26th Annual
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Congress 18-21 October 2017 Antalya ORAL{" "}
                            </span>
                            <span className="s13" style={{ backgroundColor: "" }}>
                                25th
                            </span>
                        </p>
                        <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <span className="s10" style={{ backgroundColor: "" }}>
                                B27. Isikoglu Mete,{" "}
                            </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Aydinuraz Batu; Urshanova Amilya, Urfan Avci Aysenur
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Hysteroscopic evaluation is justified in recurrent implantation
                                failures. ESGE 26th Annual
                            </span>
                            <span className="p"> </span>
                            <span className="s11" style={{ backgroundColor: "" }}>
                                Congress 18-21 October 2017 Antalya POSTER{" "}
                            </span>
                            <span className="s13" style={{ backgroundColor: "" }}>
                                25th
                            </span>
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                    </li>
                    <li data-list-text="C.">
                        <p
                            className="s1"
                            style={{ paddingLeft: "19pt", textIndent: "-14pt", textAlign: "left" }}
                        >
                            Yazılan uluslararası kitaplar veya kitaplarda bölümler : (Textbook
                            chapters)
                        </p>
                        <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>C1. Isikoglu M, </b>Ozgur K,, Berkkanoglu M, “The Use of GnRH
                            Antagonists in Ovarian Stimulation For Intrauterine Insemination”,
                            <i>INTRAUTERINE INSEMINATION</i>, ed. G.N. Allahbadia 440-445, Jaypee
                            Brothers Medical Publishers (P) Ltd New Delhi, 2005. 1st edition ISBN
                            81-8061-433-6
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            <b>C2. </b>Berkkanoglu M, <b>Isikoglu M</b>, Ozgur K, “Genetics of
                            Premature Ovarian Failure”{" "}
                            <i>Gynecological Endoscopy and Infertility, </i>eds. Allahbadia Gautam
                            Nandkishore, Merchant Rubina, Verhoeven Hugo C, De Wilde Rudy Leon
                            154-161, Jaypee Brothers Medical Publishers (P) Ltd New Delhi, 2006. 1st
                            edition ISBN 81-8061-506-5
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>C3. </b>Berkkanoglu M, <b>Isikoglu M</b>, Ozgur K, “Endometriosis and
                            Infertility” <i>Gynecological Endoscopy and Infertility</i>, eds.
                            Allahbadia Gautam Nandkishore, Merchant Rubina, Verhoeven Hugo C, De
                            Wilde Rudy Leon393-399, Jaypee Brothers Medical Publishers (P) Ltd New
                            Delhi, 2006. 1st edition ISBN 81-8061-506-5
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>C4. Isikoglu M</b>, Ozgur K, “Nuclear Transfer – Can it be an answer
                            for the aging oocyte?"{" "}
                            <i>Contemporary Perspectives on Assisted Reproductive Technology. </i>GN
                            Allahbadia, R Merchant, 313-317 Elsevier -A division of Reed Elsevier
                            India Private Limited Mosby, Saunders, Churchill Livingstone,
                            Butterworth Heinemann and Hanley and Belfus are the Health Science
                            imprints of Elsevier, New Delhi 2006 1st edition ISBN 8181477820
                        </p>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            C5. <span className="p">OZGUR K, M.D. </span>Isikoglu M
                            <span className="p">
                                , M.D., “Müllerian anomalies and art” INFERTILITY, ART &amp; ENDOSCOPY
                                – LESSONS LEARNT &amp; FUTURE CHALLENGES. Gautam Allahbadia MD , Hugo
                            </span>
                        </h2>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            Verhoeven MD, Rudi De Wilde, Rubina Merchant Ph.D 2005
                        </p>
                        <p style={{ paddingTop: "11pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>C6. </b>Berkkanoglu M, <b>Isikoglu M</b>, Ozgur K, “Ovarian Tissue
                            Transplantation in Humans”{" "}
                            <i>Contemporary Perspectives on Assisted Reproductive Technology. </i>GN
                            Allahbadia, R Merchant, 346-350 Elsevier -A division of Reed Elsevier
                            India Private Limited Mosby, Saunders, Churchill Livingstone,
                            Butterworth Heinemann and Hanley and Belfus are the Health Science
                            imprints of Elsevier, New Delhi 2006 1st edition ISBN 8181477820
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                lineHeight: "12pt",
                                textAlign: "left"
                            }}
                        >
                            C7. ISIKOGLU METE,BERKKANOGLU MURAT,CEMAL HASIM,ÖZGÜR KEMAL
                        </h2>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            Polycystic Ovary Syndrome, Bölüm adı:(Polycystic Ovary Syndrome: What is
                            the Role of Obesity?) (2007)., , Anshan Ltd, Editör:Gautam N Allahbadia,
                            Rina Agrawal, Basım
                        </p>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            sayısı:1,
                        </p>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            C8. Isikoglu M,{" "}
                            <span className="p">
                                Dundar O, “Management of Tubo-cornual Polyps: Good Medical Practice”,
                                The Fallopian Tube, ed. G.N. Allahbadia, E Saridogan, O Djahanbakhch,
                                256-260, Anshan Ltd YS, 2009.
                            </span>
                        </h2>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            C9. Isikoglu M{" "}
                            <span className="p">
                                The Fallopian Tube, Bölüm adı:(Risk Factors for Ectopic Pregnancy)
                                (2009). Anshan, Editör:G.N. Allahbadia, E Saridogan, O Djahanbakhch,
                                Basım sayısı:1, Sayfa Sayısı 723
                            </span>
                        </h2>
                        <p
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>C10 Isikoglu M</b>“The Use of GnRH Antagonists in Ovarian Stimulation
                            For Intrauterine Insemination”, <i>INTRAUTERINE INSEMINATION</i>, 3rd
                            edition, ed. G.N. Allahbadia 103-108, Jaypee Brothers Medical Publishers
                            (P) Ltd New Delhi, 2014.
                        </p>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            C11. Isikoglu M,{" "}
                            <span className="p">
                                Seleker M, Ozgur K, “The Effect of Smoking on Semen Quality in
                                Infertile Men”, Reproductive Medicine; Challenges, Solutions and
                                Breakthroughs, ed. S Arora, R Merchant, G.N. Allahbadia 503-507,
                                Jaypee Brothers Medical Publishers (P) Ltd New Delhi, 2014.
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            C12. Ayse Seyhan, Mete Isikoglu, Baris Ata,{" "}
                            <span className="p">
                                “Embryo transfer media and catheters”, Human Embryo Transfer, ed. G.N.
                                Allahbadia, C.F. Chillik 69-77, Springer India, 2015. DOI
                                10.1007/978-81-322-1115-0_9
                            </span>
                        </h2>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <span className="s14" style={{ backgroundColor: "" }}>
                                C13. Isikoglu M,{" "}
                            </span>
                            <span className="s15" style={{ backgroundColor: "" }}>
                                “GnRH Antagonists in Mild Stimulation Protocols”, Baskıda
                            </span>
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            <span className="s14" style={{ backgroundColor: "" }}>
                                C14. Isikoglu M{" "}
                            </span>
                            <span className="s15" style={{ backgroundColor: "" }}>
                                "GNRHa Trigger: Why, When, How?" Progress in Ovarian Stimulation
                            </span>
                            <span className="p"> </span>
                            <span className="s15" style={{ backgroundColor: "" }}>
                                Protocols – Volume I Editor(s): Dr. Gautam N Allahbadia and Dr. Goral
                                Gandhi. Springer:
                            </span>
                            <span className="p"> </span>
                            <span className="s15" style={{ backgroundColor: "" }}>
                                in press
                            </span>
                        </p>
                        <p style={{ paddingTop: "6pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            className="s16"
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
                        >
                            <span className="h2">C15. Isikoglu M</span>
                            <span style={{ color: "#000" }}>
                                Outcome of vitrified-thawed embryo transfer in the GnRH agonist versus
                                antagonist protocols. Textbook of Assisted Reproduction –{" "}
                            </span>
                            Editors: <b>Allahbadia</b>, G., <b>Ata</b>, B., <b>Lindheim</b>, S.R.,{" "}
                            <b>Woodward</b>, B., <b>Bhagavath</b>, B. (Eds.) pp 419-423
                        </p>
                    </li>
                    <li data-list-text="D.">
                        <p
                            className="s1"
                            style={{
                                paddingTop: "3pt",
                                paddingLeft: "20pt",
                                textIndent: "-15pt",
                                textAlign: "left"
                            }}
                        >
                            Ulusal hakemli dergilerde yayımlanan makaleler : (National publications)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <a name="bookmark1">‌</a>
                            <b>D1.</b>Has R, <b>Işıkoğlu M</b>, Beşışık S, Akkaya H, “Pyelonefritle
                            Komplike Olmuş Bir Gebede Derin Anemi”,{" "}
                            <i>İstanbul Jinekoloji ve Obstetrik Dergisi, </i>cilt:3 sayı:1,61-63
                            (1999)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>D2. </b>Yıldırım A, Akhan SE,
                            <b>Işıkoğlu M</b>, İyibozkurt C, “Management of Pregnancy in Chronic
                            Renal Failure: Case presentation and review of the literature”,{" "}
                            <i>Gynecology Obstetrics and Reproductive Medicine </i>Vol 5,
                            No:2,116-119 (1999)
                        </p>
                        <h2
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            D3<span className="p">. Has R, </span>Işıkoğlu M, “
                            <span className="p">Peritonun kapatılması”, </span>
                            <i>İstanbul Jinekoloji ve Obstetrik Dergisi,</i>
                        </h2>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            cilt:3 sayı:3,164-165 (1999)
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            <b>D4</b>. Karan A, Ayyıldız H, Aksaç B, <b>Işıkoğlu M</b>, Beji NK,
                            Eskiyurt N, Yalçın Ö, “Üriner İnkontinansta Elektrik Stimülasyonu ve
                            Egzersiz Tedavisinin Altı Aylık Kontrol Sonuçları”,{" "}
                            <i>İstanbul Jinekoloji ve Obstetrik Dergisi, </i>Cilt:3 sayı:3, 187-190
                            (1999)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>D5. </b>Yıldırım A, <b>Işıkoğlu M</b>, Karalök MH, “Documentation of
                            The Cases Diagnosed With Abruptio Placenta Between 1994 and 1998 at
                            Istanbul Medical Faculty Obstetrics and Gynecology Clinic”,{" "}
                            <i>Medical Bulletin of Istanbul Medical Facult, </i>Volume:33 No:1,
                            53-56 (2000)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>D6</b>. Karan A, Aksaç B, Ayyıldız H,
                            <b>Işıkoğlu M</b>, Yalçın Ö, Eskiyurt N, “Üriner inkontinanslı
                            hastalarda yaşam kalitesi ve objektif değerlendirme parametreleri ile
                            ilişkisi”, <i>Geriatri </i>3(3), 102-106 (2000)
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>D7</b>. Karan A,
                            <b>Işıkoğlu M</b>, Aksaç B, Attar E, Eskiyurt N, Yalçın Ö, “Stres Üriner
                            İnkontinanslı Hastalarda Hipermobilite Sendromu”, Türkiye{" "}
                            <i>Fiziksel Tıp ve Rehabilitasyon Dergisi</i>, cilt:3 sayı:3, 12-16
                            (2000)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>D8. </b>Has R, <b>Işıkoğlu M</b>, Akhan S, Ermiş H, İbrahimoğlu L,
                            “Makat Prezentasyonunda Doğum Şeklinin Perinatal Sonuçlar Üzerine
                            Etkisi”, <i>İstanbul Jinekoloji ve Obstetrik Dergisi</i>, 4,71-77 (2000)
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>D9. </b>Yalçın Ö, Işıkoğlu M, Attar E, “Üriner inkontinansta hormon
                            replasman tedavisinin yeri”, <i>Hipokrat,</i>9,631-634 (2000)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>D10. </b>Has R, İbrahimoğlu L, Attar E, Balcı C, <b>Işıkoğlu M</b>,
                            Topuz S, “Cerebral Hemorrhage Associated with HELLP Syndrome:
                            Presentation of Two Cases”,{" "}
                            <i>Gynecology Obstetrics and Reproductive Medicine, </i>7,166-168 (2001)
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>D11. </b>Özgür K,
                            <b>Işıkoğlu M, “</b>Multifetal Embriyo Redüksiyonunda Güvenli Bir
                            Yöntem: 8. Haftada Transvaginal Yoldan İntratorasik KCL İnjeksiyonu”,{" "}
                            <i>Türk Fertilite Dergisi</i>, 10,190- 196 (2002)
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            D12. <span className="p">Ozgur K,</span>Isikoglu M
                            <span className="p">
                                , “Successful outcome of 152 high order multifetal pregnancies after
                                transvaginal pregnancy reduction and comparison with nonreduced
                                twins”,{" "}
                            </span>
                            <i>Uzmanlık Sonrası Eğitim ve Güncel Gelişmeler </i>
                            <span className="s18">Dergisi </span>
                            <span className="s19">2006;3:38-45</span>
                        </h2>
                        <p style={{ paddingTop: "2pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>D13. </b>Ozgur K, <b>Isikoglu M</b>, “
                            <i>
                                <b>Editöre mektup</b>
                            </i>
                            : Successful outcome of 152 high order multifetal pregnancies after
                            transvaginal pregnancy reduction and comparison with nonreduced twins”,{" "}
                            <i>Uzmanlık Sonrası Eğitim ve Güncel Gelişmeler Dergisi </i>2006;3:215
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            D14. Işıkoğlu M,{" "}
                            <span className="p">
                                “İntrauterin inseminasyon için over stimülasyonunda GnRH
                                antagonistlerinin kullanımı” J Turk Soc Obstet Gynecol 2013, 10: 250-5
                            </span>
                        </h2>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                    </li>
                    <li data-list-text="E.">
                        <p
                            className="s1"
                            style={{ paddingLeft: "20pt", textIndent: "-14pt", textAlign: "left" }}
                        >
                            Ulusal bilimsel toplantılarda sunulan ve bildiri kitaplarında basılan
                            bildiriler:
                        </p>
                        <p
                            className="s1"
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
                        >
                            National presentations
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>E1. </b>Yalçın Ö, <b>Işıkoğlu M</b>, Atar E, Günay S, Ayyıldız H,
                            “Üriner inkontinansta hormon replasman tedavilerinin etkileri”,{" "}
                            <i>1. Ulusal Ürojinekoloji Kongresi, </i>8-11 Haziran, İstanbul, 1999
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <a name="bookmark2">‌</a>
                            <b>E2.</b>Günay S, <b>Işıkoğlu M</b>, Ayyıldız H, Yalçın Ö, “Stres
                            üriner inkontinans ve detrusor instabilitesinde inkontinans anamnezinin
                            tanısal değerliliği”, <i>1. Ulusal Ürojinekoloji Kongresi</i>, 8-11
                            Haziran, İstanbul, 1999
                        </p>
                        <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>E3. </b>Kızılkaya N, Yalcin Ö, Ayyıldız H, <b>Işıkoğlu M</b>, Günay
                            S, “Kadınlarda stres üriner inkontinans risk faktörlerinin belirlenmesi”{" "}
                            <i>1. Ulusal Ürojinekoloji Kongresi</i>, 8-11 Haziran İstanbul, 1999
                        </p>
                        <p
                            className="s3"
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>E4. Işıkoğlu M</b>
                            <span className="p">
                                , Yalçın Ö, Günay S, Yazıcı G, Ayyıldız H, “Türkiye’deki kadınlarda
                                üriner ve anal inkontinansın prevalansı”,{" "}
                            </span>
                            1<span className="s9">st </span>International Congress on the Menopause
                            &amp; The 4<span className="s9">th </span>National Congress,{" "}
                            <span className="p">17-21 May, Antalya, 2000</span>
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <h2
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            E5. <span className="p">Aksaç B, Akı S, Karan A, Yalçın Ö, </span>
                            Işıkoğlu M
                            <span className="p">
                                , Eskiyurt N, “Stres üriner inkontinans rehabilitasyonunda biofeedback
                                ve pelvik taban kas egzersizlerinin kısa dönem etkinliği”,
                            </span>
                        </h2>
                        <p
                            className="s3"
                            style={{
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                lineHeight: "12pt",
                                textAlign: "left"
                            }}
                        >
                            2. Ulusal ürojinekoloji kongresi
                            <span className="p">, 17-19 Nisan, İstanbul,2002</span>
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>E6. Işıkoğlu M</b>“Heterotopic Cervical Pregnancy: Conservative
                            Treatment With Transvaginal Embryo Reduction” TSRM 2014, 6.Ulusal Üreme
                            Endokrinolojisi ve İnfertilite Kongresi<i>, </i>06 – 09 Kasım, Antalya
                            (2014) (Poster sunumu)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>E7</b>. <b>Işıkoğlu M</b>, Tanriverdi Ozcelik N, Koksal C, Adiguzel
                            D, Aslanbas S, Yazan S, Avci A “Arcuate Uterus And Pregnancy Loss: Which
                            Is The Cause And Which Is The Outcome?” TSRM 2014, 6.Ulusal Üreme
                            Endokrinolojisi ve İnfertilite Kongresi<i>, </i>06 – 09 Kasım, Antalya
                            (2014) (Sözlü sunu)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>E8</b>. <b>Işıkoğlu M</b>, Think twice before abdominal delivery:
                            adverse effects of C-section on fertility and on embryo transfer
                            procedure TSRM 2016, 7. Ulusal Üreme Endokrinolojisi ve İnfertilite
                            Kongresi<i>, </i>17– 20 Kasım, Antalya (2016) (Sözlü sunu)
                        </p>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            <b>E9</b>. <b>Işıkoğlu M</b>, Modified natural protocol seems superior
                            to natural and artificial protocols for preparing the endometrium in
                            frozen embryo transfer cycles. TSRM 2016, 7. Ulusal Üreme
                            Endokrinolojisi ve İnfertilite Kongresi<i>, </i>17– 20 Kasım, Antalya
                            (2016) (Sözlü sunu)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            <b>E10</b>.{" "}
                            <b>
                                Batu Aydınuraz, Mete Işıkoğlu, Ayşe Kendirci Çeviren, Ayşenur Urfan
                                Avcı
                            </b>
                            , Clinical efficacy of endometrial receptivity array: case series. TSRM
                            2016, 7. Ulusal Üreme Endokrinolojisi ve İnfertilite Kongresi<i>,</i>17–
                            20 Kasım, Antalya (2016) (Sözlü sunu)
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                    </li>
                    <li data-list-text="F.">
                        <p
                            className="s1"
                            style={{ paddingLeft: "19pt", textIndent: "-13pt", textAlign: "left" }}
                        >
                            <a name="bookmark3">‌</a>Diğer yayınlar :
                        </p>
                    </li>
                </ol>
                <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <a name="bookmark4">‌</a>VERDİĞİ KONFERANSLAR (Conferences)
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F1.{" "}
                    <span className="p">
                        “Transvaginal Embryo-reduction for high order Multifetal ART pregnancies”
                    </span>
                </h2>
                <p
                    className="s3"
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    World association of Reproductive Medicine. 2nd World Congress “Gametes and
                </p>
                <p
                    className="s3"
                    style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}
                >
                    Alternatives: New Challenges in Reproductive Medicine
                    <span className="p">, May 6-9, Rome,Italy (2004)</span>
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F2. </b>“GnRHa administration during the luteal phase in In vitro
                    fertilization patients: is it beneficial?”{" "}
                    <i>
                        The fifth Indian congress on gynecological endoscopy, infertility &amp;
                        ART{" "}
                    </i>
                    November 25-28, Khajuraho,India (2004)
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    <b>F3. “</b>Cost effective ovarian stimulation protocols”{" "}
                    <i>
                        The fifth Indian congress on gynecological endoscopy, infertility &amp;
                        ART
                    </i>
                    November 25-28, Khajuraho, India (2004)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F4. </b>“Public opinion regarding oocyte donation in Turkey: data from a
                    secular population among the islamic world”,{" "}
                    <i>Third International Egg Donation Conference</i>, 4-5 February, London, UK
                    (2005)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F5. </b>“Endometrial polyps smaller than 1.5 cm which are encountered
                    during controlled ovarian stimulation do not affect ICSI outcome”{" "}
                    <i>Asiapacific congress on egg donation and third party reproduction </i>
                    November 24-27, Pondicherry, India (2005)
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F6. </b>“Public opinion regarding oocyte donation in Turkey : First data
                    from a secular population among the Islamic world”
                    <i>Asiapacific congress on egg donation and third party reproduction </i>
                    November 24-27, Pondicherry, India (2005)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F7. </b>“Endometrial polyps encountered during controlled ovarian
                    stimulation: Do they affect ICSI outcome?”,{" "}
                    <i>
                        The Uterus in ART International Symposium &amp; Pre- Symposium Workshops
                        on Ultrasound and Hysteroscopy{" "}
                    </i>
                    Nisan 13-16, Antalya (2006)
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F8. </b>“The impact of endometrial polyps on assisted reproductive
                    treatment outcome”,{" "}
                    <i>World association of Reproductive Medicine. 3rd World Congress </i>
                    September 28- October 1, Rome, Italy (2006)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F9. </b>“The effect of rosiglitazone on ICSI outcome in PCOS patients”{" "}
                    <i>
                        Indo-French Congress on Gynecologic Endoscopy, Ultrasound and Infertility{" "}
                    </i>
                    23-26 November, Varanasi, India (2006)
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F10. </b>“The effect of smoking on semen quality in infertile men”,{" "}
                    <i>
                        Indo-French Congress on Gynecologic Endoscopy, Ultrasound and Infertility{" "}
                    </i>
                    23-26 November, Varanasi, India (2006)
                </p>
                <p
                    style={{
                        paddingTop: "3pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F11. </b>“Klomifen sitrat, insülin duyarlaştırıcılar, aromataz enzim
                    inhibitörleri”,{" "}
                    <i>
                        Üreme Endokrinolojisi İnfertilite ve Yardımla Üreme Teknikleri Derneği
                        (TSRM) Kurs konuşması{" "}
                    </i>
                    27 Ocak, Gaziantep (2007)
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    <b>F12. </b>“Management of tubocornual polyps: Good medical practice”{" "}
                    <i>World Congress on Fallopian Tubes </i>October 18-21, Kolkata, India
                    (2007)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <b>F13. </b>“Hydrosalpinx and Assisted Peproduction: options and rationale
                    for treatment” <i>World Congress on Fallopian Tubes </i>October 18-21,
                    Kolkata, India (2007)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    F14.{" "}
                    <span className="p">
                        “Endoskopi eğitiminde yeni teknolojiler” II. Jinekolojik Endoskopi
                        Kongresi 4-7 Nisan,
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Çeşme-İzmir (2007)
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F15.{" "}
                    <span className="p">
                        “Attitudes of Turkish and Iranian People Towards Egg Donation” Royan
                        Institute, 5-7 September, Tehran-Iran (2007)
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    F16.{" "}
                    <span className="p">
                        “Endometrial polyps encountered during controlled ovarian stimulation : do
                        they affect ICSI outcome?” Turkish Israeli Symposium, New Trends in
                        Assisted Reproduction Treatments, August 23, 2008
                    </span>
                </h2>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F17.{" "}
                    <span className="p">
                        “Türk çiftlerin oosit ve sperm bağışına yaklaşımı” 3. Ulusal Üreme
                        Endokrinolojisi ve İnfertilite Kongresi 16-19 Ekim 2008 Antalya
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    F18.{" "}
                    <span className="p">
                        “YÜT’de veri toplanması: Güncel sorunlar” 3. Ulusal Üreme Endokrinolojisi
                        ve İnfertilite Kongresi 16-19 Ekim 2008 Antalya
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <span className="h2">F19. </span>
                    <span className="p">“History of a cross border donor IVF program” </span>
                    <span className="s3">World association of Reproductive Medicine</span>
                    <span className="s21" style={{ backgroundColor: "" }}>
                        . 5th World Congress
                    </span>
                    <span className="p">, March 7-9, Wien, Austria (2010)</span>
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <span className="h2">F20. </span>
                    <span className="p">“History of a cross border donor IVF program” </span>
                    <span className="s3">World association of Reproductive Medicine. </span>
                    <span className="s21" style={{ backgroundColor: "" }}>
                        5th World Congress
                    </span>
                    <span className="p">, October 10-13, Moscow, Russia (2010)</span>
                </p>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "14pt",
                        textAlign: "left"
                    }}
                >
                    <span style={{ backgroundColor: "" }}>October 2010</span>
                    <span className="s23" style={{ backgroundColor: "" }}>
                        Volume 20, Supplement 3, Page S48 RBM Online
                    </span>
                </p>
                <p style={{ paddingTop: "1pt", textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    F21.{" "}
                    <span className="p">
                        M Isikoglu “Opening Speech” Safe, Patient Friendly And Low Cost IVF A Road
                        To The Future an International Symposium, 23-25 april 2010 Antalya,
                        Turkiye
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F22.{" "}
                    <span className="p">
                        “Kötü yanıt veren hastalarda protokol seçimi” Özel Tüp Bebek Merkezleri
                        Derneği
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    Sempozyum-2: Merkezler arası standardizasyon çalışmaları 18-19 Haziran,
                    İzmir (2011)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F23.{" "}
                    <span className="p">
                        “Ovaryan Stimülasyonda Kanser Riski” 5. Ulusal Üreme Endokrinolojisi ve
                        İnfertilite
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    Kongresi 27-30 Eylül Çeşme, İzmir (2012)
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F24.{" "}
                    <span className="p">
                        “Ovaryan Stimülasyonda Kanser Riski” 5. Ulusal Üreme Endokrinolojisi ve
                        İnfertilite
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Kongresi 27-30 Eylül Çeşme, İzmir (2012)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <b>F25. </b>İnfertilite: Nereden Nereye. Mehmet Akif Ersoy Üniversitesi{" "}
                    <span className="s19">17 Mayıs 2012 </span>Burdur
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F26.{" "}
                    <span className="p">
                        “Anovülasyonun yönetimi” Uludağ Kış Kongresi 7-10 Mart 2013 Bursa Türkiye
                    </span>
                </h2>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F27. </b>“Arcuate uterus and pregnancy loss: which is the cause and which
                    is the outcome?” 2nd{" "}
                    <i>
                        World Congress on Ovulation Induction and Ovarian Stimulation Protocols
                        ,August 7
                    </i>
                    - 10, Jaipur, India (2014)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F28. </b>“Scheduling GnRH antagonist cycles” 2nd{" "}
                    <i>
                        World Congress on Ovulation Induction and Ovarian Stimulation Protocols
                        ,August 7
                    </i>
                    -10, Jaipur, India (2014)
                </p>
                <p
                    style={{
                        paddingTop: "3pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    <b>F29. </b>“IVF öncesi optimal hasta hazırlığı nasıl olmalı?” Özel Tüp
                    Bebek Merkezleri Derneği Güncel Tartışmalı Konular Sempozyumu
                    <i>, 20 Eylül</i>, İzmir (2014)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F30.{" "}
                    <span className="p">
                        “Bir laboratuvar testi olarak AMH ne kadar güvenilirdir?” TSRM 2014,
                        6.Ulusal
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    Üreme Endokrinolojisi ve İnfertilite Kongresi<i>, </i>06 – 09 Kasım, Antalya
                    (2014)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <b>F31. </b>“Arcuate uterus ve gebelik kaybı: Hangisi sebep hangisi sonuç?”
                    13. Ulusal Jinekoloji ve Obstetrik Kongresi<i>, </i>11 – 15 Mayıs, Antalya
                    (2015)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <b>F32</b>. <b>Işıkoğlu M</b>, Sezaryenin fertilite ve embriyo transferi
                    üzerine olumsuz etkileriTJOD 2016, 14. Ulusal Jinekoloji ve Obstetrik
                    Kongresi<i>, </i>05– 09 Ekim, Antalya (2016)
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F33<span className="p">.</span>Işıkoğlu M
                    <span className="p">
                        , OHSS: Tarihe mi karışmalı? TSRM 2016, 7. Ulusal Üreme Endokrinolojisi
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    ve İnfertilite Kongresi<i>, </i>17– 20 Kasım, Antalya (2016)
                </p>
                <p
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    <b>F34</b>. <b>Işıkoğlu M</b>, “Think twice before abdominal delivery:
                    Adverse effects of C-section on fertility and on embryo transfer procedure”
                    2nd World Congress on Embryo Transfer &amp; Intrauterine Insemination (WETI
                    2016), <span style={{ color: "#212121" }}>8th - 11th December </span>
                    Ahungalla, Sri Lanka (2016)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F35</b>. <b>Işıkoğlu M</b>, “Think twice before abdominal delivery:
                    Adverse effects of C-section on fertility and on embryo transfer procedure”
                    2nd World Congress on Embryo Transfer &amp; Intrauterine Insemination (WETI
                    2016), <span style={{ color: "#212121" }}>8th - 11th December </span>
                    Ahungalla, Sri Lanka (2016)
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F36<span className="p">.</span>Işıkoğlu M
                    <span className="p">
                        , “Oocyte Quality in Endometriosis” International Pelvic Pain Society
                        Meeting and 1st Congress of Society of Pelvic Pain and Endometriosis’ May
                        4 - 6, İstanbul 2017
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F37. Işıkoğlu M
                    <span className="p">
                        , “İnfertilitede laparoskopinin yeri” 2018 Çukurova Kadın Doğum Günleri
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    21-23 Eylül 2018 Adana
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F38. Işıkoğlu M
                    <span className="p">
                        , “İntramural myomlar ve infertilite” 8. Ulusal Üreme Sağlığı ve
                        İnfertilite
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Kongresi 8-11 Kasım 2018 Antalya
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F39. Işıkoğlu M
                    <span className="p">
                        , “Panel: Üremeye yardımcı tedavilerde güncel sorunlar ve çözüm önerileri”
                        8. Ulusal Üreme Sağlığı ve İnfertilite Kongresi 8-11 Kasım 2018 Antalya
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    F40. Işıkoğlu M
                    <span className="p">
                        , “Ovülasyon İndüksiyonunda Oral Ajanların Hangisini Kullanalım?” 1.
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Çukurova IVF Günleri 11-13 Ocak 2019 Adana
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F41. Işıkoğlu M
                    <span className="p">
                        , 12.12.2018 TSRM Webinar: Türkiye’de konvansiyonel IVF neden yok?
                    </span>
                </h2>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F42. Işıkoğlu M
                    <span className="p">
                        , “Ovülasyon indüksiyonunda oral ajanlar” İnfertilite ve ART’de tartışmalı
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    konular sempozyumu 23-24 Şubat 2019 Antalya
                </p>
                <p
                    style={{
                        paddingTop: "11pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    <b>F43. Işıkoğlu M</b>, “Panel:
                    <span className="s25">Interactive case discussions with the experts</span>”
                    III. International Expermed Congress 11-14 Nisan 2019 Bafra, KKTC
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F44. Işıkoğlu M
                    <span className="p">
                        , “Üreme Sağlığında Laboratuvarın Rolü” Uluslararası Laboratuvar Tıbbı
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    ve 19. Ulusal Klinik Biyokimya Kongresi 25-28 Nisan 2019 Bodrum
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F45. Işıkoğlu M
                    <span className="p">
                        , “İntrauterin İnseminasyon” 2. Uluslararası Üreme Sağlığı ve İnfertilite
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Kongresi 4-5 Mayıs 2019 Bakü/Azerbaycan
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    F46. Işıkoğlu M
                    <span className="p">
                        , “Endometrium preparation protocols in frozen embryo transfer cycles”
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    2nd Debatable Topics in Obstetrics Gynecology and Infertility 14-15 Feb 2018
                    Tehran/Iran
                </p>
                <h2
                    style={{
                        paddingTop: "3pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F47. Işıkoğlu M
                    <span className="p">
                        , “Ovülasyon indüksiyonunda oral ajanlar” İnfertilite ve ART’de tartışmalı
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    konular sempozyumu TSRM 23-24 Şubat 2019 Antalya
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    F48. Işıkoğlu M
                    <span className="p">
                        , “One size does not fit all: individualized COS” 20th Royan International
                        Twin Congress 28-30 August 2019 Tehran/Iran
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F49. Işıkoğlu M
                    <span className="p">
                        , “From triggering to i-triggering” 20th Royan International Twin Congress
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    28-30 August 2019 Tehran/Iran
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F50. Işıkoğlu M
                    <span className="p">
                        , “Increased delivery rate: does your patient has only one chance?” 20th
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    Royan International Twin Congress 28-30 August 2019 Tehran/Iran
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F51. Işıkoğlu M
                    <span className="p">
                        , “Counting down the oocytes” 20th Royan International Twin Congress
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    28-30 August 2019 Tehran/Iran
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F52. Işıkoğlu M
                    <span className="p">
                        , “GnRH antagonists under microscope” 20th Royan International Twin
                        Congress 28-30 August 2019 Tehran/Iran
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    F53. Işıkoğlu M
                    <span className="p">
                        , “i-Trigger: better results expected” 20th Royan International Twin
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Congress 28-30 August 2019 Tehran/Iran
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F54. Işıkoğlu M
                    <span className="p">
                        , “Freezing your lab” 20th Royan International Twin Congress 28-30 August
                        2019 Tehran/Iran
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    F55. Işıkoğlu M
                    <span className="p">
                        , “Türkiye’de Konvansiyonel IVF neden yok?” VII. Üreme Tıbbı ve Cerrahisi
                        Derneği Kongresi 3-6 Ekim 2019 Antalya
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    F56. Işıkoğlu M
                    <span className="p">
                        , “Panel: Stimülasyondan implantasyona IVF” TSRM Denizli Sempozyumu Her
                        yönüyle infertilite 7-8 Mart 2020 Denizli
                    </span>
                </h2>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F57. Işıkoğlu M
                    <span className="p">
                        , 09.06.2021 TSRM Webinar: Konvansiyonel IVF geri dönüyor
                    </span>
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F58. Işıkoğlu M
                    <span className="p">
                        , Gürkan Bozdağ, Faruk Buyru, Işıl Kasapoğlu, Stratis Kolibianakis 13
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    Haziran 2021 TSRM Online Panel: Tüp Bebekte Mitler ve Gerçekler
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    F59. Işıkoğlu M
                    <span className="p">
                        , “Luteal Faz Desteğinin Bireyselleştirilmesi” 9. Üreme Sağlığı ve
                        İnfertilite
                    </span>
                </h2>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Kongresi 11-14 Kasım 2021 Titanic Kongre Merkezi, Belek-Antalya
                </p>
                <h2
                    style={{
                        paddingTop: "12pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    F60. Işıkoğlu M
                    <span className="p">
                        , “Ovülasyon indüksiyonu: endikasyon ve protokoller” TJOD Antalya Şubesi
                        İnfertilite Sempozyumu 24 Nisan 2022 Kepez Mimar Sinan Kongre ve Sergi
                        Merkezi Antalya
                    </span>
                </h2>
                <h2
                    style={{
                        paddingTop: "11pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F61. Işıkoğlu M
                    <span className="p">
                        , “Luteal Faz Desteğinin Bireyselleştirilmesi” TSRM Online Sempozyumu
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    IVF Laboratuvarında Ek Tedaviler 13 Şubat 2022
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}>
                    <b>F62. Işıkoğlu M</b>, “From national data collection to transnational
                    registries: <i>the Turkish experience</i>” ESHRE Closed EIM Consortium
                    Meeting 6-7 May 2022 Belgrade/Serbia
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    F63. Işıkoğlu M
                    <span className="p">
                        , “Klivaj Dönemi Embryo Transferi” Üreme Tıbbı ve Cerrahisi Derneği
                    </span>
                </h2>
                <p
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "12pt",
                        textAlign: "left"
                    }}
                >
                    Webinar 12 Mayıs 2022
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    WANA 8-9 June 2022 Kish Island/Iran
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Ekim Kıbrıs
                </p>
                <p
                    style={{
                        paddingTop: "3pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "left"
                    }}
                >
                    Kasım ÜTD Antalya
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <a name="bookmark5">‌</a>VİDEO SUNUMLARI (Video presentations)
                </h2>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <ol id="l2">
                    <li data-list-text={1}>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            Correction of Complete Uterine Septum with two cervical ostia
                            Asiapacific congress on egg donation and third party reproduction
                            November 24-27 2005 Pondicherry India
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                    </li>
                    <li data-list-text={2}>
                        <p
                            style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                        >
                            Correction of Complete Uterine Septum with two cervical ostia "The
                            Uterus in ART" International Symposium &amp; Pre-Symposium Workshops on
                            Ultrasound and Hysteroscopy Nisan 13-16 2006 Antalya
                        </p>
                    </li>
                    <li data-list-text={3}>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            Histeroscopic Correction Of Subseptum Uteri In Two Cases. Indo-French
                            Congress on Gynecologic Endoscopy, Ultrasound and Infertility 23-26
                            November 2006 Varanasi, India
                        </p>
                        <p style={{ textIndent: "0pt", textAlign: "left" }}>
                            <br />
                        </p>
                    </li>
                    <li data-list-text={4}>
                        <p
                            style={{ paddingLeft: "16pt", textIndent: "-10pt", textAlign: "left" }}
                        >
                            Histeroskopik subseptum uteri insizyonu: iki olgu. II. Jinekolojik
                            Endoskopi Kongresi 4-
                        </p>
                        <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                            7 Nisan, Çeşme-İzmir (2007)
                        </p>
                    </li>
                    <li data-list-text={5}>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "justify"
                            }}
                        >
                            Hysteroscopic removal of an unusual foregin object. ESGE 24th Annual
                            Congress 2015 Budapest, Hungary <span className="s26">25th</span>
                        </p>
                    </li>
                    <li data-list-text={6}>
                        <p
                            style={{
                                paddingTop: "12pt",
                                paddingLeft: "5pt",
                                textIndent: "0pt",
                                textAlign: "left"
                            }}
                        >
                            Hysteroscopic Incision of a Complete Uterine Septum With a Single
                            Cervix. ESGE 25th Annual Congress 02-05 October 2016 Brussels
                            <span className="s26">25th</span>
                        </p>
                    </li>
                </ol>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h1 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    Yazılan Ulusal Kitap Bölümleri ve Bölüm Çevirileri
                </h1>
                <p
                    className="s19"
                    style={{
                        paddingTop: "3pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        textAlign: "justify"
                    }}
                >
                    Attar EN,
                    <b>Işıkoğlu M</b>, “Jinekoloji, Pratik Yaklaşım (Gynecology, A Practical
                    Approach)”, V. Gomel, M. G. Munro, T. C. Rowe. Williams&amp;Wilkins
                    copyright 1995-Atlas kitapçılık Tic. Ltd. Şti. Ankara
                </p>
                <h1
                    style={{
                        paddingTop: "13pt",
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "14pt",
                        textAlign: "left"
                    }}
                >
                    Işıkoğlu M
                    <span className="s19">, Attar E, “Endometriozis ve tedavisi”</span>
                </h1>
                <p
                    className="s19"
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "14pt",
                        textAlign: "left"
                    }}
                >
                    “Gomel’in Jinekolojisi”, Editörler: Prof Dr. Erkut Attar, Dr. Barış Ata
                    Nobel Tıp Kitabevi 2007
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <h1
                    style={{
                        paddingLeft: "5pt",
                        textIndent: "0pt",
                        lineHeight: "14pt",
                        textAlign: "left"
                    }}
                >
                    Işıkoğlu M
                    <span className="s19">
                        , “Over rezervinin değerlendirilmesi-Testing ovarian reserve”
                    </span>
                </h1>
                <p
                    className="s19"
                    style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                >
                    “In Vitro Fertilization a Practical Approach”, David K Gardner, Informa
                    Healthcare copyright 1995 Çeviri editörü: Prof. Dr. Hasan Serdaroğlu- Hayat
                    Tıp Kitapçılık İstanbul (2008)
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p
                    className="s19"
                    style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "justify" }}
                >
                    <b>Mete Isikoglu, Batu Aydınuraz,</b>“D Vitamini ve Anti Müllerian Hormon
                    Düzeyi Arasındaki İlişki”,{" "}
                    <span className="h2">
                        İnfertil Kadınlarda D Vitamininin Değerlendirilmesi
                    </span>
                    , ed. Yılmaz Atay, Türkiye Klinikleri 2020
                </p>
                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                    <br />
                </p>
                <p style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    <span className="s10" style={{ backgroundColor: "" }}>
                        YAYIN HAKEMLİĞİ
                    </span>
                </p>
                <ol id="l3">
                    <li data-list-text={1}>
                        <p
                            style={{
                                paddingTop: "6pt",
                                paddingLeft: "16pt",
                                textIndent: "-10pt",
                                textAlign: "left"
                            }}
                        >
                            <span className="s10" style={{ backgroundColor: "" }}>
                                Türk Jinekoloji ve Obstetrik Derneği Dergisi, (J Turk Soc Obstet
                                Gynecol)
                            </span>
                        </p>
                        <ul id="l4">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Histeroskopik Tubal Sterilizasyon (TJOD 16362-0)
                                    </span>
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        GnRH Agonisti Kullanılan ICSI Sikluslarında Seri Serum Estradiol
                                        Düzeyi ve
                                    </span>
                                    <span className="p"> </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Endometrial Kalınlık Ölçümlerinin Gebelik Sonuçlarına Etkisi
                                    </span>
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        3 kez düşük doz metotreksat uygulaması ile tedavi edilmiş kornual
                                        gebelik: Olgu
                                    </span>
                                </p>
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "0pt",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        sunumu (TJOD 28190-0)
                                    </span>
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Ovaryan Hiperstimülasyon Sendromu ve Adneksiyal Torsiyon: Olgu
                                        Sunumu
                                    </span>
                                    <span className="p"> </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        (87699-0)
                                    </span>
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        46, XX, del(8)(q22), der(9) t(8;9)(q22;p24) Dengeli Translokasyon
                                        Taşıyıcısı
                                    </span>
                                    <span className="p"> </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Hipogonadotropik Hipogonadizm Olgusu (22590-0)
                                    </span>
                                </p>
                                <p
                                    style={{ paddingTop: "8pt", textIndent: "0pt", textAlign: "left" }}
                                >
                                    <br />
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={2}>
                        <p
                            style={{ paddingLeft: "16pt", textIndent: "-10pt", textAlign: "left" }}
                        >
                            <span className="s10" style={{ backgroundColor: "" }}>
                                Journal of Assisted Reproduction and Genetics
                            </span>
                        </p>
                        <ul id="l5">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "5pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Vitrified blastocysts from Preimplantation Genetic Diagnosis (PGD)
                                        as a source for
                                    </span>
                                    <span className="p"> </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        human Embryonic Stem Cell (hESC) derivation (JARG1611)
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={3}>
                        <p
                            style={{ paddingLeft: "16pt", textIndent: "-10pt", textAlign: "left" }}
                        >
                            <span className="s10" style={{ backgroundColor: "" }}>
                                Journal of Reproduction and Contraception
                            </span>
                        </p>
                        <ul id="l6">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Ovarian cysts in users of two kind of only-progestin
                                        contraceptives implants (
                                    </span>
                                    <span className="s27" style={{ backgroundColor: "" }}>
                                        JRC
                                    </span>
                                    <span className="p"> </span>
                                    <span className="s27" style={{ backgroundColor: "" }}>
                                        E2006-07
                                    </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        )
                                    </span>
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                    <br />
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    <a name="bookmark6">‌</a>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Application of Hysteroscopy in Female Infertility (
                                    </span>
                                    <span className="s27" style={{ backgroundColor: "" }}>
                                        Zuan-chong FENG
                                    </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        )
                                    </span>
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "9pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        First pregnancies/babies from cryopreserved oocytes in Hungary (
                                    </span>
                                    <span className="s27" style={{ backgroundColor: "" }}>
                                        JRC E2006-13
                                    </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        )
                                    </span>
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        Fertility preservation for female (
                                    </span>
                                    <span className="s27" style={{ backgroundColor: "" }}>
                                        JRC E2006-16
                                    </span>
                                    <span className="s11" style={{ backgroundColor: "" }}>
                                        )
                                    </span>
                                </p>
                                <p style={{ textIndent: "0pt", textAlign: "left" }}>
                                    <br />
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={4}>
                        <h2
                            style={{ paddingLeft: "16pt", textIndent: "-10pt", textAlign: "left" }}
                        >
                            Europeon Journal of Obstetrics Gynecology and Reproductive Biology
                        </h2>
                        <ul id="l7">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "3pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "justify"
                                    }}
                                >
                                    Removal of completely incarcerated intrauterine device in the
                                    myometrium by means of hysteroscopy: one case report
                                    (EJOGRB-12-8942R1)
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "150%",
                                        textAlign: "justify"
                                    }}
                                >
                                    The outcome of singleton pregnancies after IVF/ICSI in women before
                                    and after the hysteroscopic resection of a uterine septum compared
                                    to the normal controls (EJOGRB-07-3371)
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    Vaginal Length and Incidence of Dyspareunia after Total Abdominal
                                    versus Vaginal Hysterectomy (EJOGRB-09-5231)
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={5}>
                        <h2
                            style={{ paddingLeft: "16pt", textIndent: "-10pt", textAlign: "left" }}
                        >
                            International Journal of Fertility and Sterility
                        </h2>
                        <ul id="l8">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    Views on assisted reproduction techniques from a cross-sectıon of
                                    society (IJFS- 858)
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    A survey on oocyte donation: Turkish fertile and infertile women’s
                                    opinions (IJFS- 612)
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={6}>
                        <h2
                            style={{
                                paddingLeft: "21pt",
                                textIndent: "-15pt",
                                lineHeight: "12pt",
                                textAlign: "left"
                            }}
                        >
                            VF Lite
                        </h2>
                        <ul id="l9">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    Use of Oral Contraceptives in Assisted Reproductive Cycles
                                    (ivflite_2_13)
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={7}>
                        <h2
                            style={{
                                paddingTop: "6pt",
                                paddingLeft: "16pt",
                                textIndent: "-10pt",
                                textAlign: "left"
                            }}
                        >
                            Journal of Medical Case Reports
                        </h2>
                        <ul id="l10">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        textAlign: "left"
                                    }}
                                >
                                    Cornual heterotopic pregnancy: a case report (Olivier Poujade).
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li data-list-text={8}>
                        <h2
                            style={{
                                paddingTop: "6pt",
                                paddingLeft: "16pt",
                                textIndent: "-10pt",
                                textAlign: "left"
                            }}
                        >
                            Reproductive Biomedicine Online
                        </h2>
                        <ul id="l11">
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingTop: "6pt",
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    Zoroastrians support oocyte and embryo donation program for
                                    infertile couples (RBMO-D-13-00272R1)
                                </p>
                            </li>
                            <li data-list-text="•">
                                <p
                                    style={{
                                        paddingLeft: "41pt",
                                        textIndent: "-18pt",
                                        lineHeight: "149%",
                                        textAlign: "left"
                                    }}
                                >
                                    Hysteroscopic polypectomy without cycle cancellation in IVF cycles
                                    (RB 3689 Madani et al)
                                </p>
                            </li>
                        </ul>
                    </li>
                </ol>
                <h2 style={{ paddingLeft: "5pt", textIndent: "0pt", textAlign: "left" }}>
                    8.Current Women’s Health Review (CWHR)
                </h2>
            </>
        </div>
    )
}
